import "./Home.module.css";
import VaultHeader from "@/reusable_sections/Header";
import Blueprint from "./sections/Blueprint";
import Architects from "./sections/Architects";
import Engines from "./sections/Engines";
import Performance from "./sections/Performance";
import MarketAuthority from "./sections/MarketAuthority";
import Secure from "./sections/Secure";
import VaultFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <VaultHeader />
      <Blueprint />
      <Architects />
      <Engines />
      <Performance />
      <MarketAuthority />
      <Secure />
      <VaultFooter />
    </div>;
}